export enum CLPApplianceDetailsPersonDetailsFormField {
  Address = 'address',
  FirstName = 'firstName',
  Surname = 'surname',
  Title = 'title',
}
